import { getGlobalKeystrokes as a } from "@rwh/keystrokes";
export * from "@rwh/keystrokes";
import { createContext as l, useState as n, useContext as d, useEffect as c } from "react";
const P = () => a(), f = l(P), i = (s) => {
  const [r, t] = n(!1), e = d(f)();
  return c(() => {
    const o = {
      onPressed: () => t(!0),
      onReleased: () => t(!1)
    };
    return e.bindKey(s, o), () => {
      e.unbindKey(s, o);
    };
  }, [e]), r;
}, p = (s) => {
  const [r, t] = n(!1), e = d(f)();
  return c(() => {
    const o = {
      onPressed: () => t(!0),
      onReleased: () => t(!1)
    };
    return e.bindKeyCombo(s, o), () => {
      e.unbindKeyCombo(s, o);
    };
  }, [e]), r;
};
export {
  i as useKey,
  p as useKeyCombo
};
